module.exports = __webpack_public_path__ + "img/banner.3ba39f7e.jpg";